import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "day-modal" }
const _hoisted_2 = { class: "day-modal__title" }
const _hoisted_3 = {
  key: 0,
  class: "day-modal__description"
}
const _hoisted_4 = { class: "day-modal__table-container" }
const _hoisted_5 = { class: "day-modal__table-container--content day-modal__content" }
const _hoisted_6 = {
  key: 0,
  class: "day-modal__content-title-and-sum"
}
const _hoisted_7 = { class: "day-modal__content-title day-modal__content-title--confirm" }
const _hoisted_8 = { class: "day-modal__content-sum" }
const _hoisted_9 = { class: "day-modal__content--bold" }
const _hoisted_10 = { class: "day-modal__content-title day-modal__content-title--pending" }
const _hoisted_11 = { class: "day-modal__content-sum" }
const _hoisted_12 = { class: "day-modal__content-sum--bold" }
const _hoisted_13 = { class: "day-modal__table-wrapper" }
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 1,
  class: "day-modal__button-container"
}
const _hoisted_16 = {
  key: 2,
  class: "day-modal__button-container"
}

import { ref, computed, watch, h } from 'vue';
import { storeToRefs } from 'pinia';
import { useOrderCalendarStore } from '../pages/orderCalendarStore';
import { CalendarOrderService } from '../domains/services/CalendarOrderService';
import Modal from '@/components/modal/Modal.vue';
import { i18n } from '@/i18n';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';
import OrderAlert from '@/corePagesModule/BaseTableContent/components/order/OrderAlert.vue';
import OrderStatusBadge from '@/corePagesModule/components/OrderStatusBadge.vue';
import EditableTableCell from '@/corePagesModule/BaseTableContent/components/EditableTableCell.vue';
import Btn from '@/components/input/Btn/Btn.vue';
import { CalendarOrder } from '../domains/entities/CalendarOrder';
import { simpleCopy } from '@/utils/deepCopy';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import { useRouter } from 'vue-router';
import { DateService } from '@/coreDomainsModule/services/dateService';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import { IOrderGroup } from '@/coreDomainsModule/entities/IOrderGroup';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import OrderGroupInfoSection from '@/corePagesModule/components/OrderGroup/OrderGroupInfoSection.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DayModal',
  emits: ["onSaved"],
  setup(__props, { emit: __emit }) {

const t = i18n.t;

const router = useRouter();

const orderCalendarStore = useOrderCalendarStore();
const checkIds = ref<string[]>([]);

const { state } = storeToRefs(orderCalendarStore);
const { getOrdersByDate, setModalInfo, saveOrders, updateStateOrders } = orderCalendarStore;

const emits = __emit;

const orders = computed(() =>
  state.value.modalInfo.day !== undefined ? simpleCopy(getOrdersByDate(state.value.modalInfo.day)) : undefined
);
const changeableOrders = computed(() => orders.value?.filter((order) => CalendarOrderService.isChangeableCrossDate(order)) ?? []);
const fixedOrders = computed(() => orders.value?.filter((order) => !CalendarOrderService.isChangeableCrossDate(order)) ?? []);
// 変更された発注を取得する
const amountChangedOrders = computed(() => orders.value?.filter((order) => changedOrderIds.value.includes(order.arrivalId)) ?? []);
const sumAmountByFixed = computed(() => {
  return changeableOrders.value.reduce((acc, order) => acc + order.amount, 0);
});
const sumAmountByChangeable = computed(() => {
  return fixedOrders.value.reduce((acc, order) => acc + order.amount, 0);
});
// 単位を取得する
const unit = computed(() => {
  if (orders.value && orders.value.length > 0) {
    return orders.value[0].unit;
  }
  return '';
});

// ヘッダー要素の高さ
const fixedOrdersTableHead = ref<HTMLTableSectionElement | null>(null);
// テーブル全体の高さ
const maxTableHeight = ref(0);
// 数量編集モードかどうか
const isEditingAmount = ref(false);
// 変更された発注ID
const changedOrderIds = ref<string[]>([]);
// 発注ステータス編集モードかどうか
const isEditingStatus = ref(false);
// アラートモーダルを開いているindex
const alertModalIndex = ref<number | null>(null);

watch(
  () => alertModalIndex.value,
  (newVal, oldVal) => {
    console.log('alertModalIndex', oldVal, newVal);
  }
);

// テーブルのgrid-template-columns
const gridTemplateColumns: string[] = ['50px', '120px', '155px', '155px', '155px', '80px', '155px', '155px', '90px', '110px', '90px'];

/**
 * モーダルを閉じるボタンがクリックされたときに呼び出されるハンドラ
 * @param isResetDay - 日付をリセットするかどうか
 */
const closeModal = (isResetDay?: boolean) => {
  const day = isResetDay ? undefined : state.value.modalInfo.day;
  setModalInfo(false, day);
};

/**
 * モーダルの状態をリセットする
 */
const reset = () => {
  checkIds.value = [];
  isEditingAmount.value = false;
  isEditingStatus.value = false;
  changedOrderIds.value = [];
  resetEditingValue();
};

/**
 * 変更ボタンがクリックされたときに呼び出されるハンドラ
 */
const clickSubmitChange = async () => {
  // 上限数量チェック
  if (amountChangedOrders.value.some((order) => order.orderGroupId)) {
    const checkUpperLimitQuantityRes = await checkOrderGroupUpperLimitQuantity();
    if (!checkUpperLimitQuantityRes) return;
  }

  // checkIdsをリセット
  checkIds.value = [];

  // ステータス編集モードに移行
  isEditingAmount.value = false;
  isEditingStatus.value = true;
};

/**
 * 数量編集した発注が発注グループの上限に引っかかってないかを確認する
 */
const checkOrderGroupUpperLimitQuantity = async (): Promise<boolean> => {
  if (state.value.modalInfo.day === undefined) return false;
  const orderGroupsWithLinkedOrderList: Map<IOrderGroup, CalendarOrder[]> = new Map(
    state.value.orderGroupList.map((group) => [
      group,
      amountChangedOrders.value.filter((order) => order.orderGroupId === group.orderGroupId),
    ])
  );
  let invalid: { orderGroup: IOrderGroup; changedAmountDiff: number }[] = [];
  const originalOrderList = getOrdersByDate(state.value.modalInfo.day);
  orderGroupsWithLinkedOrderList.forEach((orderList, orderGroup) => {
    if (!orderGroup || orderList.length === 0) return;
    const changedAmountDiff = orderList.reduce((acc, order) => {
      acc += order.amount - (originalOrderList.find((originalOrder) => originalOrder.arrivalId === order.arrivalId)?.amount ?? 0);
      return acc;
    }, 0);
    if (orderGroup.totalLinkedOrderAmount + changedAmountDiff > orderGroup.upperLimitQuantity) {
      invalid.push({ orderGroup, changedAmountDiff });
    }
  });
  if (invalid.length > 0) {
    await showInfoModal({
      modalTitle: t('発注グループの上限数量オーバー'),
      modalDescription: t('発注グループの上限数量の引き上げ、または各発注の数量を上限数量に収まるようにしてください。'),
      modalContent: h(
        'div',
        {
          style: {
            padding: '16px',
            display: 'grid',
            gridTemplateRows: `repeat(${invalid.length}, auto)`,
            borderRadius: '8px',
            backgroundColor: '#f5f5f5',
          },
        },
        invalid.map((data) =>
          h(OrderGroupInfoSection, {
            orderGroupName: data.orderGroup.orderGroupName,
            numberOfOrder: data.orderGroup.linkedOrderCount,
            upperLimitQuantity: data.orderGroup.upperLimitQuantity,
            totalAmount: data.orderGroup.totalLinkedOrderAmount,
            afterTotalAmount: data.orderGroup.totalLinkedOrderAmount + data.changedAmountDiff,
            hasBackground: false,
          })
        )
      ),
      backButtonLabel: 'OK',
      icon: 'error',
      colorStyle: 'error',
      enableOutsideClick: false,
      isDisabledNextButton: true,
      modalWidth: 764,
    });
    return false;
  }
  return true;
};

/**
 * 承認依頼ボタンがクリックされたときに呼び出されるハンドラ
 * @param isChange - ステータスを変更するかどうか
 */
const clickSubmitStatusChange = async (isChange: boolean) => {
  const targetIds = changedOrderIds.value;
  if (isChange) {
    // ステータスを変更する場合
    if (targetIds.length > 0) {
      // 変更された発注のステータスを変更する
      const targetOrders = orders.value?.filter((order) => targetIds.includes(order.arrivalId));
      targetOrders?.forEach((order) => {
        order.status = OrderStatus.ApprovalRequested;
      });
    }
  }

  // 変更された発注がない場合は何もしない
  // NOTE: ここで発注が存在しないことは想定されていない
  if (targetIds.length === 0) {
    reset();
    closeModal(true);
    return;
  }

  // 変更した発注データを取得
  const changedOrders = orders.value?.filter((order) => changedOrderIds.value.includes(order.arrivalId));

  // モーダルを閉じる
  closeModal();

  // 変更された発注を保存する
  const repository = new OrderRepository();
  const result = await waitLoading(saveOrders(repository, changedOrders));
  reset();

  emits('onSaved', result?.status.type === 'success');
};

/**
 * 数量変更ボタン押下時のハンドラ
 */
const clickChangeAmount = () => {
  isEditingAmount.value = true;
};

/**
 * キャンセルボタン押下時のハンドラ
 */
const clickCancel = async () => {
  resetEditingValue();
  isEditingAmount.value = false;
};

/**
 * 編集した値をリセットする
 */
const resetEditingValue = () => {
  const day = state.value.modalInfo.day;
  state.value.modalInfo.day = undefined;
  state.value.modalInfo.day = day;
};

/**
 * 数量が編集されたときに呼び出されるハンドラ
 * @param order - 変更された発注
 * @param amountStr - 変更された数量
 */
const changeOrderAmount = (order: CalendarOrder, amountStr: string): void => {
  // number型に変換する
  const amount = parseInt(amountStr, 10);
  if (Number.isNaN(amount)) {
    console.error('数量が数値ではありません');
    return;
  }

  // 数量が変更されているかどうかを確認する
  if (order.amount === amount) {
    return;
  }

  // 変更された数量をセットする
  order.amount = amount;

  // 変更された発注をメモする
  if (!changedOrderIds.value.includes(order.arrivalId)) {
    changedOrderIds.value.push(order.arrivalId);
  }
};

/**
 * 発注が変更可能かどうかを判定する
 * @param order - 発注
 */
const isChangeable = (order: CalendarOrder): boolean => {
  return CalendarOrderService.isChangeableQuantity(order);
};

/**
 * アウトサイドクリック時のハンドラ
 */
const handleOutsideClick = () => {
  reset();
  closeModal();
};

/**
 * アラート内の確認ボタンをクリックした際の処理
 * @param alertKind - アラートの種類
 * @param order - 発注
 */
const onClickCheckButtonInAlert = (alertKind: string, order: CalendarOrder) => {
  if (alertKind === 'orderAmountWarning') {
    // 詳細ページに移動する
    window.open(`#/business/recommend-order/${order.parentBusinessId}`, '_blank');
  }
};

/**
 * deliveryDateの文字列を取得する
 * @param order - 発注
 */
const getDeliveryDate = (order: CalendarOrder): string => {
  if (order.crossDate) {
    return DateService.convertIYearMonthDayToYYYYMMDDWithi18n(order.crossDate);
  }
  return '';
};

/**
 * アラートモーダルの開閉を切り替える
 * @param index - 対象のインデックス
 * @param toOpenModal - 開こうとしているかどうか
 */
const toggleAlertModal = (index: number, toOpenModal: boolean) => {
  if (toOpenModal) {
    // 開こうとしている場合はindexをセット
    alertModalIndex.value = index;
    return;
  }

  // 閉じようとしている場合
  if (alertModalIndex.value !== index) {
    // 対象のindexと開かれているindexが異なる場合、既にindexが切り替わっているため何もしない
    return;
  }
  // 正常に閉じれる場合はnullにセット
  alertModalIndex.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-state": _unref(state).modalInfo.isOpen,
    "stretch-container": true,
    "scroll-off": true,
    padding: "0",
    "border-radius": "16px",
    "no-padding-and-margin": false,
    "modal-size": "max-content",
    "is-force-no-style": true,
    onOutsideClick: handleOutsideClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('発注カレンダー(モーダル)', {
            year: _unref(state).modalInfo.day?.year,
            month: _unref(state).modalInfo.day?.month,
            day: _unref(state).modalInfo.day?.day,
          })), 1),
        (isEditingStatus.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('承認依頼を行う発注を選択してください。')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!isEditingStatus.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('納期確定')), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_unref(t)('合計：')), 1),
                    _createElementVNode("b", _hoisted_9, _toDisplayString(sumAmountByChangeable.value.addComma()) + _toDisplayString(unit.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('納期未確定')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_unref(t)('合計：')), 1),
                    _createElementVNode("b", _hoisted_12, _toDisplayString(sumAmountByFixed.value.addComma()) + _toDisplayString(unit.value), 1)
                  ]),
                  _createVNode(Btn, {
                    class: "day-modal__change-amount-btn",
                    "button-style": "btn-secondary",
                    disabled: isEditingAmount.value,
                    onClick: clickChangeAmount
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('数量を編集')), 1)
                    ], undefined, true),
                    _: 1
                  }, 8, ["disabled"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(EzTable, {
                "grid-template-columns": gridTemplateColumns,
                "sticky-header": ""
              }, {
                header: _withCtx(() => [
                  _createVNode(EzHeader, { class: "day-modal__table__header" }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('集計ID')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('置場名')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('商品CD')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('商品名')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('容量')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('仕入先名')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('発注番号')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('発注数量')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('ステータス')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(EzHeader, { class: "day-modal__table__header" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('アラート')), 1)
                    ], undefined, true),
                    _: 1
                  })
                ]),
                body: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(isEditingStatus.value ? amountChangedOrders.value : orders.value, (order, index) => {
                    return (_openBlock(), _createBlock(EzTableRow, {
                      id: `day-modal-table-row-${index}`,
                      key: order.arrivalId,
                      "grid-template-columns": gridTemplateColumns,
                      class: "day-modal__table__row"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(EzCell, {
                          class: "day-modal__table__data",
                          "force-center": ""
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkIds).value = $event)),
                              class: "day-modal__table__checkbox",
                              type: "checkbox",
                              value: order.arrivalId
                            }, null, 8, _hoisted_14), [
                              [_vModelCheckbox, checkIds.value]
                            ])
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, { class: "day-modal__table__data" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.parentBusinessId), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, { class: "day-modal__table__data" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.warehouse), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, { class: "day-modal__table__data" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.businessNumber), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, { class: "day-modal__table__data" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.businessName), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, { class: "day-modal__table__data" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.package), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, { class: "day-modal__table__data" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.supplierName), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, { class: "day-modal__table__data" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.number || '--'), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, {
                          class: "day-modal__table__data",
                          "force-right": ""
                        }, {
                          default: _withCtx(() => [
                            (isEditingAmount.value && isChangeable(order))
                              ? (_openBlock(), _createBlock(EditableTableCell, {
                                  key: 0,
                                  "input-type": "number",
                                  "text-value": order.amount.toString(),
                                  onChangeText: ($event: any) => (changeOrderAmount(order, $event))
                                }, null, 8, ["text-value", "onChangeText"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(order.amount.addComma()), 1)
                                ], 64))
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, { class: "day-modal__table__data" }, {
                          default: _withCtx(() => [
                            _createVNode(OrderStatusBadge, {
                              "order-status-str": order.status
                            }, null, 8, ["order-status-str"])
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, { class: "day-modal__table__data" }, {
                          default: _withCtx(() => [
                            _createVNode(OrderAlert, {
                              class: "day-modal__table__alert",
                              "alert-types": _unref(state).orderAlertMap[order.arrivalId],
                              "order-amount": order.amount.toString(),
                              "delivery-date": getDeliveryDate(order),
                              "is-opening": alertModalIndex.value === index,
                              onClick: ($event: any) => (toggleAlertModal(index, $event)),
                              onOnNext: ($event: any) => (onClickCheckButtonInAlert($event, order))
                            }, null, 8, ["alert-types", "order-amount", "delivery-date", "is-opening", "onClick", "onOnNext"])
                          ], undefined, true),
                          _: 2
                        }, 1024)
                      ], undefined, true),
                      _: 2
                    }, 1032, ["id"]))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (isEditingAmount.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(Btn, {
                class: "day-modal__button day-modal__button--cancel",
                onClick: clickCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(Btn, {
                class: "day-modal__button day-modal__button--save",
                disabled: changedOrderIds.value.length === 0,
                onClick: clickSubmitChange
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('変更')), 1)
                ], undefined, true),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true),
        (isEditingStatus.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(Btn, {
                class: "day-modal__button day-modal__button--cancel",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (clickSubmitStatusChange(false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('承認依頼しない')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(Btn, {
                class: "day-modal__button day-modal__button--save",
                disabled: checkIds.value.length === 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (clickSubmitStatusChange(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('承認依頼する')), 1)
                ], undefined, true),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})